import { create } from "zustand";
import { AccountsState } from "../_types/accounts.types";

export const useAccountsStore = create<AccountsState>((set) => ({
  role: "all",
  subscription: "all",
  period: "all",
  search: "",
  page: 1,
  limit: 10,
  setRole: (role) => set({ role, page: 1 }),
  setSubscription: (subscription) => set({ subscription, page: 1 }),
  setPeriod: (period) => set({ period, page: 1 }),
  setSearch: (search) => set({ search, page: 1 }),
  setPage: (page) => set({ page }),
  setLimit: (limit) => set({ limit, page: 1 }),
}));
